// const API_BASE = 'http://192.168.1.81:8000'
const API_BASE = '/api/v1';

export default class Api{

    constructor(store, telegram){
        this.store = store;
        this.tg = telegram;
        this.universeID = 0;
        this.heroID = 0;
        this.storyID = 0;
    }

    async auth(){
        const data = {
            initData: this.tg.getInitData(),
        }
        const response = await fetch(`${API_BASE}/auth`,
            {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(data),
            }
        );
        // if (!response.ok) throw new Error(`send initData response is not ok: ${response.status}`);
        return response.status;
    }

    async fetchWrapper(path, options){
        let response = await fetch(path);
        if (response.status !== 401){
            return response
        }
        
        const authStatus = await this.auth();
        if (authStatus !== 200){
            return;
        }
        
        response = await fetch(path);
        return response
    }

    async getAllUniverses(){
        // const response = await fetch(`${API_BASE}/universes`);
        const response = await this.fetchWrapper(`${API_BASE}/universes`)
        if (!response.ok) throw new Error
          const universes = await response.json();
        return universes.map(universe => ({
            id: universe.id,
            name: universe.name,
            description: universe.description,
        }));
    }

    async getHeroesByUnID(){
        if (this.universeID === 0){
            this.universeID = this.store.getUniverseID();
        }else{
            this.store.setUniverseID(this.universeID);
        }
        // const response = await fetch(`${API_BASE}/heroes?id=${this.universeID}`);
        const response = await this.fetchWrapper(`${API_BASE}/heroes?id=${this.universeID}`);
        if (!response.ok) throw new Error
        const heroes = await response.json();
        return heroes.map(hero => ({
            id: hero.id,
            name: hero.name,
            image: hero.image_source
        }));
    }

    async getHeroStories(){
        if (this.heroID === 0){
            this.heroID = this.store.getHeroID();
        }else{
            this.store.setHeroID(this.heroID);
        }
        const response = await this.fetchWrapper(`${API_BASE}/stories?id=${this.heroID}`)
        // const response = await fetch(`${API_BASE}/stories?id=${this.heroID}`);
        if (!response.ok) throw new Error
        const stories = await response.json();
        return stories.map(story => ({
            id: story.id,
            name: story.name,
            description: story.story_description
        }));
    }

    async getBalanceAndPrice(){
        const response = await this.fetchWrapper(`${API_BASE}/balance`)
        // const response = await fetch(`${API_BASE}/price`);
        if (!response.ok) throw new Error
        const priceList = await response.json();
        return {
            currentBalance: priceList.currentBalance,
            messagePrice: priceList.messagePrice,
            imagePrice: priceList.imagePrice
        };
    }

    async getBalanceUp(){
        const response = await fetch(`${API_BASE}/invoices`);
        if (!response.ok) throw new Error
        const balancesUp = await response.json();
        return balancesUp.map(balanceUp => ({
            tokens: balanceUp.tokens,
            price: balanceUp.price
        }));
    }

    async startDialog(){
        const data = {
            'hero_id': this.heroID,
            'story_id': this.storyID,
        };
        const response = await fetch(`${API_BASE}/dialog/start`, 
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            }
        );
        if (!response.ok) throw new Error('Create new dialog is failed: status code is: ', response.status);
    }

    async upBalance(data){
       const response = await fetch(`${API_BASE}/balance/up`, 
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            }
        );
        if (!response.ok) throw new Error('Create new dialog is failed: status code is: ', response.status);
    }

}